import i18n from "@/i18n";
import { createDocumentsType, searchDocumentsType, searchDocumentFamilyList, createDocumentsFamily, createAssociationMethode, getAssociation, getDocumentType, updateDocumentType, deleteDocumentType, getDocumentTypeWithAssociations, createDocumentTypeAssociations, executUpdateDocumentsType, documentTypeExists } from "@/store/services/configuration/documentsService";
import { DocumentsState} from "@/types";
import Notify from 'quasar/src/plugins/Notify.js';;
import { Module } from "vuex";

const documentsModule: Module<DocumentsState, unknown> = {
  namespaced: true,
  state: {
    selectedDocumentFamily:{
      objectType: "odm.supportingdocument.supportingdocumentfamily",
      systemUid: "odm-supportingdocument",
      resourceUid: '',
      reference:'',
      daaq:"/",
      isMandatory:false
    },
    selectedDocumentType: {
      objectType: "odm.supportingdocument.documenttype",
      systemUid: "odm-supportingdocument",
      resourceUid: '',
      reference:'',
      daaq:"/",
      selectedFamilies: []
    }
  },
  getters: {
    getSelectedDocumentFamily: (state): any | undefined => {
      return state.selectedDocumentFamily;
    },
    getSelectedDocumentType: (state): any | undefined => {
      return state.selectedDocumentType;
    },
  },
  actions: {
    searchDocumentsType({ commit }, payload) {
        const { filter,offset,limit, callback } = payload;
        searchDocumentsType(filter,offset,limit)
          .then((res) => {
            callback(res);
          })
          .catch((e) => console.error(e));
      },
      async createDocumentsType({ state, commit }, payload) {
        const { documentType, callback} = payload

        const exists = await documentTypeExists(documentType.resourceUid);

          if (exists) {
            Notify.create({
              message: i18n.global.t('Ce type de document existe déjà'),
              color: 'negative'
            });
            return;
          }
          try {
                const res: any = await createDocumentsType(documentType);
                callback(res);
              } catch (e) {
                console.error(e);
              }
        },
          searchDocumentFamilyList({ commit }, payload) {
            const { filter,offset,limit, callback } = payload;
            searchDocumentFamilyList(filter,offset,limit)
              .then((res) => {
                callback(res);
              })
              .catch((e) => console.error(e));
          },
          saveDocumentFamily({ commit }, payload) {
            const { documentFamily, callback} = payload
            documentFamily.resourceUid=documentFamily.reference
            delete documentFamily.reference
            delete documentFamily.isMandatory
            delete documentFamily.selectedDocuments            
            createDocumentsFamily(documentFamily)
                    .then((res:any) => {
                        commit('setDocumentFamily', res.data);
                        
                    })
                    .catch((e:any) => console.error(e))
          },
          saveAssociation({ commit }, payload) {
            const { documentFamily} = payload
            createAssociationMethode(documentFamily)
                    .then((res:any) => {
                      commit('setDocumentFamily', res);
                    })
                    .catch((e:any) => console.error(e))
          },
          getAssociation({ commit }, payload) {
            getAssociation(payload)
                    .then((res:any) => {
                      commit('setDocumentFamily', res);
                    })
                    .catch((e:any) => console.error(e))
          },
          getDocumentTypeDetails({ commit }, payload) {
            if (!payload) {
              console.error('getDocumentTypeDetails: resourceUid is required');
              return;
            }
            getDocumentTypeWithAssociations(payload)
              .then((res: any) => {
                commit('setDocumentType', res);
              })
              .catch((e: any) => {
                console.error('Error getting document type details:', e);
                Notify.create({
                  message: i18n.global.t('main.dialog.loadError', { entity: payload }),
                  color: "negative",
                })
              })
          },
          async updateDocumentType({ commit }, payload) {
            const { documentType, resourceUid, callback } = payload;
            const documentTypeCopy = { ...documentType };
            delete documentTypeCopy.selectedFamilies;
            try {
              const res = await executUpdateDocumentsType(resourceUid, documentTypeCopy)
              await callback(res);
              Notify.create({
                message: i18n.global.t('main.dialog.success', { entity: res.data?.resourceUid }),
                color: "positive",
              })
            } catch (e) {
              console.error(e);
            }
          },
          deleteDocumentType({ commit }, payload) {
            const { resourceUid, callback } = payload
            deleteDocumentType(resourceUid)
              .then((res: any) => {
                Notify.create({
                  message: i18n.global.t('main.dialog.deleteSuccess'),
                  color: "positive",
                })
                callback(res);
              })
              .catch((e: any) => {
                Notify.create({
                  message: i18n.global.t('main.dialog.deleteError'),
                  color: "negative",
                })
              })
          },
          saveDocumentTypeAssociations({ commit }, payload) {
            const { documentType, callback } = payload
            createDocumentTypeAssociations(documentType)
              .then((res: any) => {
                commit('setDocumentType', res);
              })
              .catch((e: any) => console.error(e))
              .finally(() => callback?.())
          },
          cleanState({ state, commit }) {
            commit('setInitial')
          },
  },
  mutations: {
    setDocumentFamily(state, payload) {
      state.selectedDocumentFamily = payload
      if(state.selectedDocumentFamily.isMandatory===undefined){
        state.selectedDocumentFamily.isMandatory=false
      }else{
        state.selectedDocumentFamily.isMandatory=payload.isMandatory==='true'
      }
      if(payload&&payload.resourceUid){
        state.selectedDocumentFamily.reference=payload.resourceUid

      }
      
  },
  setInitial(state) {
    state.selectedDocumentFamily = {
      objectType: "odm.supportingdocument.supportingdocumentfamily",
      systemUid: "odm-supportingdocument",
      resourceUid: '',
      reference:'',
      daaq:"/",
      isMandatory:false
    }
    state.selectedDocumentType = {
      objectType: "odm.supportingdocument.documenttype",
      systemUid: "odm-supportingdocument",
      resourceUid: '',
      reference:'',
      daaq:"/",
      selectedFamilies: []
    }
  },
  setDocumentType(state, payload) {
    state.selectedDocumentType = payload
    if (payload && payload.resourceUid) {
      state.selectedDocumentType.reference = payload.resourceUid
    }
  },
  },
};

export default documentsModule;